/* eslint-disable class-methods-use-this */
import { ProfileDto } from '@diritto/common/account/dtos/profile.dto';
import { SignUpResponseDto } from '@diritto/common/account/dtos/sign-up-response.dto';
import { UserMarketingAgreementDto } from '@diritto/common/account/dtos/user-marketing-agreement.dto';
import { WebViewTrackingEventParams } from '@diritto/common/app/webview-tracking-event.constant';
import { TrackingEventType, TrackingViewerSettingParams } from '@diritto/common/tracker/tracking-event.constant';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import BaseTrackingService from '@diritto/common/tracker/BaseTrackingService';
import { SsoType } from '@diritto/common/account/constants/sso.constant';
import { ViewerStyle } from '@diritto/common/viewer/constants/viewer.constant';

export default class AppTrackingService implements BaseTrackingService {
  trackSignIn(params: { userId: number; ssoType: SsoType }) {
    DirittoAppBridge.trackEvent(TrackingEventType.SignIn, params);
  }

  trackSignOut() {
    DirittoAppBridge.trackEvent(TrackingEventType.SignOut);
  }

  trackSignUp(signUpSsoResponseDto: SignUpResponseDto) {
    DirittoAppBridge.trackEvent(TrackingEventType.SignUp, signUpSsoResponseDto);
  }

  trackWithdrawal() {
    DirittoAppBridge.trackEvent(TrackingEventType.Withdrawal);
  }

  trackMktAgreement(userMktAgreementDto: UserMarketingAgreementDto) {
    DirittoAppBridge.trackEvent(TrackingEventType.ClickMarketingAgreement, userMktAgreementDto);
  }

  trackCreateNewProfile(profileDto: ProfileDto) {
    DirittoAppBridge.trackEvent(TrackingEventType.CreateNewProfile, { profile: profileDto });
  }

  trackChangeViewerSetting(property: { [x: string]: TrackingViewerSettingParams }) {
    DirittoAppBridge.trackEvent(TrackingEventType.ChangeViewerSetting, { property });
  }

  trackViewerSetting(properties: ViewerStyle) {
    DirittoAppBridge.trackSetPeople({ properties });
  }

  track<T extends TrackingEventType>(name: T, params: WebViewTrackingEventParams[T]) {
    setTimeout(() => DirittoAppBridge.trackEvent(name, params), 0);
  }
}
